import React, { Component } from 'react';
import UltimatePaginationBootstrap4 from 'react-ultimate-pagination-bootstrap-4';

class Pagination extends Component {
  render() {
    return (
      <UltimatePaginationBootstrap4
        currentPage={this.props.currentPage}
        totalPages={this.props.totalPages}
        onChange={page => this.props.onChange(page)}
        hideFirstAndLastPageLinks={true}
      />
    );
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/table/Pagination.js